export const isDesktopScreen = () => {
  return typeof window !== `undefined` && window.innerWidth >= 650
}
